const Bases = () => {
  return (
    <div className="global__container container marginCard">
      {/* <div className="containerTelon">
        <div className="telon"></div>
      </div> */}
      <div className="row justify-content-center">
        <div className="bases__container text-center col-12">
          <h2 className="bases__title">Bases</h2>
          <div className="text-justify">
            <p>
              1. Podrán participar hombres y/o mujeres, mexicanos o extranjeros,
              cuyo estado civil sea soltero o casado con la pareja que
              concursarán (deberán exhibir acta de matrimonio) y tengan planes
              de casarse o si la persona ganadora y su pareja ya están casados
              entre sí, van a realizar la fiesta de la boda durante el año 2022
              y, en cualquier caso, que habiten en la República Mexicana.
            </p>
            <p>
              2. Deberán ser mayores de 18 años de edad, contar con
              identificación oficial vigente con fotografía y en caso de ser
              extranjeros, acreditar su legal estancia en los Estados Unidos
              Mexicanos.
            </p>
            <p>
              3. Deberán ser cuentahabientes del programa de radio “Martha
              Debayle en W” (el “Programa”). Cualquier persona que quiera ser
              CUENTAHABIENTE puede registrarse de manera GRATUITA en la página
              de W Radio http://www.wradio.com.mx/  y en la página de Martha
              Debayle  http://marthadebayle.com/, donde una vez que se registren
              obtendrán un número único que será su registro de CUENTAHABIENTE.
              No existe ninguna limitación para ser CUENTAHABIENTE sólo hay que
              registrarse.
            </p>
            <p>
              4. La Concesionaria constatará que: i) en caso de ser solteros,
              que efectivamente la pareja tenga planes de contraer matrimonio
              durante el año 2022, y/o ii) en caso de estar casados, van a
              realizar la fiesta de la boda en este año 2022 (Llamarán a
              familiares y amigos, además se pedirán fotografías de la pareja). 
            </p>
            <p>
              5. La persona ganadora deberá declarar su amor y pedir matrimonio
              a su pareja el 12 de agosto de 2022 durante el Programa, no
              obstante que la persona ganadora y su pareja ya estén casados
              entre sí. Los gastos de transportación, hospedaje y demás que sean
              necesarios, de la persona ganadora y de su pareja, para que
              asistan al citado programa, correrán por cuenta de éstos.
            </p>
            <p>
              6. La entrega de certificados de premios se llevará a cabo el 12
              de agosto de 2022 en el Programa, excepto el premio relativo al
              vehículo automotor modelo 2022, cuya entrega se llevará a cabo una
              vez celebrado el matrimonio o si la persona ganadora y su pareja
              ya están casados entre sí, una vez realizada la fiesta de la boda.
              Los gastos de transportación, hospedaje y demás que sean
              necesarios, de la persona ganadora y de su pareja, para la entrega
              de los premios, correrán por cuenta de estos.
            </p>
            <p>
              7. La persona ganadora deberá celebrar el matrimonio y/o realizar
              la fiesta de la boda, en la Ciudad de México a más tardar el 31 de
              marzo de 2023, dicha fecha es improrrogable, salvo por causas de
              fuerza mayor o caso fortuito, fallecimiento del participante o por
              declararse una contingencia sanitaria por parte de las autoridades
              sanitarias del Gobierno Federal.
            </p>
            <p>
              8. En caso de que alguna de las personas finalistas no cumpla con
              todas las bases a la hora de mencionar las historias finalistas
              (esta información se verificará por teléfono) Martha Debayle podrá
              escoger la siguiente mejor historia y así sucesivamente hasta
              tener a las 5 personas finalistas que cumplan todas las bases.
            </p>
            <p>
              9. En caso de que la persona ganadora, por cualquier motivo, no
              celebre el matrimonio y/o realice la fiesta de la boda con la
              pareja con quien concursó, perderá su derecho sobre todos los
              premios otorgados y deberá hacer la devolución completa de los
              mismos a la Concesionaria dentro de los 15 días siguientes a la
              fecha en que la Concesionaria haya sido informada por cualquier
              medio, por parte de la persona ganadora, que no se celebrará el
              matrimonio y/o se realizará la fiesta de la boda, o bien cuando la
              Concesionaria haya corroborado la veracidad de alguna información
              recibida, por cualquier medio, por parte de la pareja con quien la
              persona ganadora celebraría el matrimonio y/o realizaría la fiesta
              de la boda.
            </p>
            <p>
              10. Una vez ocurrido lo señalado en el numeral anterior, la
              Concesionaria tendrá 30 días contados a partir de la fecha de
              dicha devolución de premios, para entregarlos en las mismas
              condiciones en que los recibió, a la persona finalista que haya
              tenido el siguiente mayor puntaje en la ronda final de preguntas
              del Concurso. De igual manera, la entrega del premio relativo al
              vehículo automotor modelo 2022 se llevará a cabo una vez celebrado
              el matrimonio o si la persona ganadora y su pareja ya están
              casados entre sí, una vez realizada la fiesta de la boda, y los
              gastos de transportación, hospedaje y demás que sean necesarios,
              de la persona ganadora y de su pareja, para la entrega de premios,
              correrán por cuenta de estos. Dicha entrega de premios se llevará
              a cabo en presencia del Supervisor de la Secretaría de
              Gobernación.
            </p>
            <p>
              11. La persona ganadora que haya tenido el siguiente mayor puntaje
              en la ronda final de preguntas deberá celebrar el matrimonio y/o
              realizar la fiesta de la boda en la Ciudad de México a más tardar
              el 31 de marzo de 2023.
            </p>
            <p>
              12. En caso de que la persona ganadora que haya tenido el
              siguiente mayor puntaje en la ronda final de preguntas, por
              cualquier motivo, decida no celebrar el matrimonio y/o realizar la
              fiesta de la boda con la pareja con quien concursó, perderá su
              derecho sobre todos los premios otorgados y deberá hacer la
              devolución completa de los mismos a la Concesionaria dentro de los
              15 días siguientes a la fecha en que la Concesionaria haya sido
              informada por cualquier medio, por parte de la persona ganadora de
              que no se celebrará el matrimonio o bien cuando la Concesionaria
              haya corroborado la veracidad de alguna información recibida, por
              cualquier medio, por parte de la pareja con quien la persona
              ganadora celebraría el matrimonio y/o realizaría la fiesta de la
              boda, para que la Concesionaria pueda utilizar los premios en
              futuras promociones.
            </p>
            <p>
              13. Asimismo, en caso de que la referida persona finalista que
              haya tenido el siguiente mayor puntaje en la ronda final de
              preguntas ya haya contraído matrimonio y/o realizado la fiesta de
              la boda (a la fecha de la devolución de premios que llevó a cabo
              la persona participante que anteriormente había resultado
              ganadora) o por cualquier motivo sea de su interés no aceptar los
              premios, perderá su derecho sobre los premios y la Concesionaria
              podrá utilizarlos en futuras promociones.
            </p>
            <p>
              14. Durante todas las etapas del Concurso, los participantes deben
              conducirse con respeto ante el personal de la Concesionaria y con
              los proveedores que brindarán los servicios para la fiesta de la
              boda, en caso contrario, perderán su derecho a continuar
              participando en el Concurso.
            </p>
            <p>
              15. Todos los participantes, incluida la persona que resulte
              ganadora junto con su pareja, deberán abstenerse de amenazar,
              insultar y denigrar al personal de la Concesionaria y/o de los
              Proveedores, tampoco grabar en audio o video sin previa
              autorización, las conversaciones que sostengan con el personal de
              la Concesionaria y/o con los Proveedores que brinden los
              servicios, así como desacreditar por cualquier medio de
              comunicación masivo, impreso o redes sociales la calidad y/o
              servicio brindado por el Concesionario y/o los Proveedores, en
              caso de acreditarse el hecho, perderán su calidad de ganador, no
              podrán reclamar los premios, siendo eliminados del Concurso y
              dichos premios pasarán a la siguiente persona que haya tenido el
              siguiente mayor puntaje y así sucesivamente hasta encontrar un
              ganador.
            </p>
            <p>
              16. Los premios son intransferibles, no sustituibles por dinero,
              ni permutables por alguno similar de mayor valor, en este caso
              correrá por cuenta del participante ganador los gastos que se
              generen.
            </p>
            <p>
              17. Únicamente se entregarán los premios enlistados en el presente
              permiso conforme a los certificados de regalo correspondientes,
              todo aquello adicional que se encuentre fuera del permiso y que
              resulte del interés del ganador, correrá por su cuenta, entiéndase
              la contratación de algún servicio adicional o la modificación de
              lo contratado por algo de mayor valor.
            </p>
            <p>
              18. En caso de que se declare una contingencia sanitaria, la
              fiesta de la boda se celebrará con el aforo permitido por las
              autoridades correspondientes, no habrá compensaciones económicas
              ni de ninguna índole con la finalidad de subsanar esta
              circunstancia.
            </p>
            <p>
              19. En aquellos casos que se acredite que el participante ganador
              o su pareja está lucrando con los premios, es decir, ofreciéndolos
              a la venta en medios impresos o plataformas digitales o
              canjeándolos por dinero o en especie, antes de recibirlos por
              parte de la Concesionaria o del Proveedor, se anulará su entrega,
              quedando a disposición del Concesionario para futuras promociones.
            </p>
          </div>
          <h2 className="bases__title">Mecánica</h2>
          <div className="text-justify">
            <p>
              1.Del 4 al 29 de julio de 2022, día en que se cerrará la convocatoria a las 00:00 horas, las personas interesadas en participar deberán ingresar a las páginas de Internet www.wradio.com.mx o www.marthadebayle.com, en el apartado del Concurso, y escribir en idioma español y en solo 1000 caracteres una historia de amor, propia, original, verdadera y comprobable junto con una fotografía de la pareja.
            </p>
            <p>
              2. Las historias serán publicadas en las páginas de internet www.wradio.com.mx y en
              <a href="http://www.marthadebayle.com/">www.marthadebayle.com</a>
            </p>
            <p>
              3.Únicamente participarán historias publicadas en dichos sitios.
            </p>
            <p>
              4. Del 1º. al 4 de agosto de 2022, un jurado integrado por la producción del
              Programa determinará a 5 personas finalistas eligiendo las historias más
              originales, creativas y emotivas.
            </p>
            <p>
              5. El 5 de agosto de 2022, serán mencionadas las 5 personas finalistas, junto con
              su respectiva pareja, en el Programa en presencia del Supervisor de la
              Secretaría de Gobernación.
            </p>
            <p>
            6. El 12 de agosto de 2022, ante la presencia de un supervisor de la Secretaría de
            Gobernación, deberán asistir al Programa las 5 personas finalistas, junto con su
            respectiva pareja, para presentar sus historias de amor y participar en una
            primera y única ronda de máximo 25 preguntas que se le hará a cada integrante
            de las parejas, relativas a la vida en pareja, su vida personal, hábitos, gustos,
            aficiones, etcétera, con la finalidad de determinar cuánto se conocen, quienes
            una vez formulada la pregunta, deberán contestarla escribiendo su respuesta en
            un pizarrón blanco individual que se les entregará, para que cuando se les
            indique, lo muestren al mismo tiempo para verificar sus respuestas y si las
            mismas coinciden se tendrá la pregunta por contestada de manera correcta.
            Cada pregunta contestada de manera correcta tendrá un valor de 20 puntos, de
            lo contrario tendrá un valor de 0 puntos.

            En esta primera y única ronda de preguntas se contarán los puntos que haya
            obtenido cada pareja, quien consiga el mayor número de puntos, será la pareja
            ganadora.

            **MUERTE SÚBITA: En cualquiera de las rondas habrá MUERTE SÚBITA sólo
            en caso de que exista un EMPATE. En ese caso Martha Debayle hará una
            pregunta a los integrantes de las parejas finalistas que empataron, relativa a lo
            antes indicado, quienes, una vez formulada la pregunta, deberán contestarla
            escribiendo su respuesta en un pizarrón blanco individual que se les entregará,
            para que cuando se les indique, lo muestren al mismo tiempo para verificar sus
            respuestas y si las mismas coinciden con la respuesta de su respectiva pareja,
            se tendrá la pregunta por contestada de manera correcta. Si todas las parejas
            finalistas que empataron contestan de manera correcta, Martha Debayle les
            hará una segunda pregunta y así sucesivamente, hasta que resulte la pareja
            finalista ganadora que será aquella primera que responda la pregunta de
            manera correcta y la o las otras parejas finalistas que empataron la contesten de
            manera incorrecta.
            </p>
            <p>
            10. Los certificados de los premios establecidos en los numerales del 1 al 13
            mencionados en el apartado de premios se entregarán a la pareja ganadora el 12 de
            agosto de 2022, ante la presencia del Supervisor de la Secretaría de Gobernación.
            </p>
            <p>
            11. El premio establecido en el numeral 14 se entregará a la persona ganadora una
            vez celebrado el matrimonio y/o realizada la fiesta de la boda, ante la presencia
            del Supervisor de la Secretaría de Gobernación.
            </p>
          </div>
          {/* <h2 className="bases__title">Reglas comunes</h2>
          <div className="text-justify">
            <p>
              1.- La Concesionaria hará entrega al supervisor o supervisora de
              la Secretaría de Gobernación de un CD que contendrá todos los
              datos de las personas que participaron en el Concurso.
            </p>
            <p>
              2.- Para que la persona ganadora pueda reclamar su premio es
              indispensable presentar identificación oficial con fotografía
              vigente y comprobante de domicilio.
            </p>
            <p>
              3.- Será responsabilidad de la persona ganadora y de su pareja
              contar con pasaporte, visa o documento vigente para el caso de que
              sea necesario al momento de viajar.
            </p>
            <p>
              4.- En caso de que alguno de los premios no sea reclamado por la
              persona ganadora en un plazo de 90 (noventa) días siguientes a que
              se hizo acreedora de los mismos, dicho premio podrá ser donado a
              la beneficencia pública o privada de la elección de la
              Concesionaria o los podrá utilizar en futuras promociones, a
              elección también de la Concesionaria.
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Bases;
